import * as React from 'react';
import { di } from 'react-magnetic-di';
import type { Category } from 'rest/category';
import GroupBoxLink from 'view/common/group-box/group-box-link';
import { AnalyticsContext } from '@atlaskit/analytics-next';

interface CategoryItemProps {
    category: Category;
    portalId: number;
    onClick?: () => void;
    className?: string;
    isEmbeddedRoute?: boolean;
}

export default class CategoryItem extends React.Component<CategoryItemProps> {
    render() {
        di(GroupBoxLink);
        const { category, portalId, onClick, className, isEmbeddedRoute } = this.props;

        const analyticData = {
            attributes: {
                portalId,
                categoryId: category.id,
            },
        };

        return (
            <AnalyticsContext data={analyticData}>
                <GroupBoxLink
                    actionSubjectId="category"
                    to={`/portal/${portalId}/topic/${category.id}`}
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                    className={className}
                    onClick={onClick}
                    heading={category.name}
                    headingAs="div"
                    isAriaHidden
                    description={category.description}
                    lineClamp={2}
                    target={isEmbeddedRoute ? '_blank' : undefined}
                />
            </AnalyticsContext>
        );
    }
}
